import { Button, Dialog, Typography } from '@cobliteam/ui/components';

interface DeleteDriverConfirmModalProps {
  open: boolean;
  loading: boolean;
  driverName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteDriverConfirmModal = ({ open, loading, driverName, onCancel, onConfirm }: DeleteDriverConfirmModalProps) => {
  return (
    <Dialog open={open} onOpenChange={(open) => !open && onCancel()}>
      <Dialog.Portal>
        <Dialog.Content size='sm'>
          <Dialog.Header>
            <Dialog.Title>Excluir motorista</Dialog.Title>
            <Dialog.Description className='sr-only' />
            <Dialog.Close onClick={onCancel} />
          </Dialog.Header>

          <Dialog.Body className='gap-5'>
            <Typography>
              Essa ação não poderá ser desfeita. Tem certeza que deseja excluir o motorista <b>{driverName}</b>?
            </Typography>
          </Dialog.Body>

          <Dialog.Footer className='flex justify-end gap-2'>
            <Dialog.Close asChild>
              <Button variant='ghost' onClick={onCancel}>
                Cancelar
              </Button>
            </Dialog.Close>
            <Button loading={loading} onClick={onConfirm} color='danger'>
              Excluir
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  );
};

export default DeleteDriverConfirmModal;
